import React, { FC } from "react";

export const NotFoundPage: FC = () => {
  return <div>Not Found</div>;
};
